import { apiHandlerWithError } from 'api';

export default async function postChatGPTCalendarItemsImport(formData) {
  return await apiHandlerWithError.post(`importers/chatgpt/save-calendar-items`, formData);
}
